import reducer from "./index";
import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const appReducer = () =>
    combineReducers({ ...reducer });

const persistConfig = {
    key: 'root',
    storage,
    // debug: true,
   whitelist: ['token'],
};


export const store = configureStore({
   reducer: persistReducer(persistConfig, appReducer()),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            // serializableCheck: {
            //     ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            // },
            serializableCheck: false
        })

});

// @ts-ignore
export type IRootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);

